import { Tooltip } from "react-leaflet";
import { TagOrBadge } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { VehicleGeolocated } from "./index";

export const VehicleLabelTooltip = (props: { vehicle: VehicleGeolocated }) => {
  const { vehicle } = props;
  return (
    <Tooltip
      direction="top"
      opacity={1}
      permanent={true}
      className="vehicle-tooltip"
    >
      <TagOrBadge
        type="TAG"
        typo={typographies["Body/S"]}
        text={`${vehicle.registrationNumber || "-"} · ${vehicle.driverName || "-"}`}
        backgroundColor={colors["colors/surfaces/background/background_level0"]}
        borderColor={colors["colors/borders/cards/cards"]}
      />
    </Tooltip>
  );
};
